// @ts-nocheck
// import { getGlobalStore } from '@/lib/global-store';
import { domainEnum } from '@/constants/global';
import marker from './marker';
// const vuexStore = getGlobalStore();
const defaultMapId = 'coord-select-map';
export default class CoordSelectMap {
    constructor(markerType = domainEnum.STORE, options = {}, mapId = defaultMapId) {
        // 'STORE' -> 'store' due to svg 파일명
        this.markerType = markerType.toLowerCase();
        this.naver = null;
        this.mapInstance = null;
        this.mapId = mapId;
        this.options = options;
        this.coordinate = options.coordinate;
        this.center = null;
        this.coordMarker = null;
        this.clickUnablePolygon = null;
    }
    init() {
        if (!document.querySelector(`#${defaultMapId}`)) {
            return;
        }
        this.naver = window.naver;
        this.center = new this.naver.maps.LatLng(this.coordinate[0], this.coordinate[1]);
        // 클릭 제한하는 바운더리 구하기(남서쪽 및 북동쪽 포인트 사이의 면적)
        // 각좌표계로 제공해야하므로 45도 방향에 가로 1의 정사각형의 대각선 길이인 1루트2 값을 적용
        const sw = this.center
            .clone()
            .destinationPoint(45, 1000 * Math.sqrt(2));
        const ne = this.center
            .clone()
            .destinationPoint(225, 1000 * Math.sqrt(2));
        const maxBounds = new this.naver.maps.LatLngBounds(sw, ne);
        // options 없을 시 명세서상 기준 정의.
        this.options = {
            center: this.center,
            minZoom: 18, // 30m
            maxZoom: 21, // 5m
            zoom: 20, // 10m
            maxBounds,
            scaleControl: true,
            mapDataControl: false,
            logoControlOptions: {
                position: this.naver.maps.Position.BOTTOM_LEFT,
            },
            scaleControlOptions: {
                position: this.naver.maps.Position.BOTTOM_LEFT,
            },
            ...this.options,
        };
        // 지도 정의
        this.mapInstance = new this.naver.maps.Map(this.mapId, {
            ...this.options,
        });
    }
    // 마커 추가하기
    setMarker(position = this.options.center) {
        const markerIcon = marker({
            naver: this.naver,
            markerType: this.markerType,
        });
        this.coordMarker = new this.naver.maps.Marker({
            position,
            map: this.mapInstance,
            icon: markerIcon,
        });
    }
    setClickUnablePolygon() {
        // ne, se, sw, nw 방위각
        const angles = [
            45,
            135,
            225,
            315,
        ];
        // 범위와 지도 밖(무한대 x 4키로미터 지점 o)
        const distances = [
            1000,
            4000,
        ];
        const sqrt2 = Math.sqrt(2);
        const points = [];
        distances.forEach((distance) => {
            angles.forEach((angle) => {
                const point = this.center.clone().destinationPoint(angle, distance * sqrt2);
                points.push(point);
            });
        });
        const [ne, se, sw, nw, neFar, seFar, swFar, nwFar,] = points;
        // 내부 가로세로 2km의 빈 정사각형 공간과 외부 가로세로 8km의 색칠된 정사각형 공간 폴리곤
        const polygonPath = [
            [
                ne,
                se,
                sw,
                nw,
            ],
            [
                neFar,
                seFar,
                swFar,
                nwFar,
            ],
        ];
        this.clickUnablePolygon = new this.naver.maps.Polygon({
            strokeOpacity: 0,
            strokeWeight: 0,
            fillOpacity: 0.2,
            fillColor: '#f00',
            paths: polygonPath,
            map: this.mapInstance,
        });
        // 마우스 클릭 이벤트 설정(바운더리 바깥은 눌리지 않기 && 바운더리 안쪽 클릭 시 마커 이동하기)
        this.naver.maps.Event.addListener(this.mapInstance, 'click', (event) => {
            // 내부 정사각형 바운더리 바깥은 클릭 할 수 없습니다.
            if (!this.options.maxBounds.hasLatLng(event.coord)) {
                return;
            }
            this.coordMarker.setPosition(event.coord);
        });
    }
    // 지도 설정 초기화
    resetOptions(isForced = false) {
        if (isForced) {
            this.destroy();
            this.init();
            this.setMarker();
            return;
        }
        const { center, zoom, } = this.options;
        // 지도 위치 초기화
        this.mapInstance.updateBy(center, zoom);
        // 마커 위치 초기화
        this.coordMarker.setPosition(center);
    }
    // 지도 삭제
    destroy() {
        this.mapInstance.destroy();
    }
    // 마커의 현재 위치(.lat() 및 .lng() 사용 가능)
    get markerPosition() {
        return this.coordMarker.getPosition();
    }
}
